module.exports = __webpack_public_path__ + "static/media/01_system.fa12ab6e.png";


//////////////////
// WEBPACK FOOTER
// ../assets/icons/01_system.png
// module id = 842
// module chunks = 0